import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";

export default function BasicModal({
  open = false,
  setOpen = () => {},
  onPress = () => {},
  text = "",
}) {
  // Styles directly using the `sx` prop
  const boxStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "white",
    borderRadius: 3,
    p: 2,
  };

  const textStyle = {
    mt: 1,
    fontSize: 16,
    color: "#333",
  };

  const btnContStyle = {
    mt: 3,
    textAlign: "right",
  };

  const btn1Style = { color: "red" };
  const btn2Style = { color: "green" };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={boxStyle}>
        <Typography variant="h3" component="h2">
          Confirmation
        </Typography>
        <Typography id="modal-modal-description" sx={textStyle}>
          {text}
        </Typography>
        <Grid sx={btnContStyle}>
          <Button sx={btn1Style} onClick={() => setOpen(false)}>
            No
          </Button>
          <Button sx={btn2Style} onClick={onPress}>
            Yes
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}
